@app.directive 'csOnHover', ->
  restrict: 'A'
  link: (scope, element, attrs) ->
    element.on 'mouseenter', (e) ->
      element.addClass 'cs-on-hover-active'

    element.on 'mouseleave', (e) ->
      element.removeClass 'cs-on-hover-active'
